import classNames from 'classnames';
import * as React from 'react';

export interface FieldErrorProps extends React.PropsWithChildren {
    className?: string;
}

export const FieldError: React.FunctionComponent<FieldErrorProps> = ({className, children}: FieldErrorProps) => (
    <p role="alert" className={classNames('mp-field-error', className)}>
        {children}
    </p>
);
